import { useState } from 'react';
import '../styles/deposit-modal.css';
import PaymentSubModal from './PaymentSubModal';

function DepositModal({ isOpen, onClose }) {
  const [selectedCard, setSelectedCard] = useState('visa');
  const [formData, setFormData] = useState({
    amount: '100.00',
    cardholderName: 'John Doe',
    cardNumber: '1234 5678 9012 3456',
    expiryDate: '12/30',
    cvv: '123',
    email: 'john@example.com'
  });

  const [submitMessage, setSubmitMessage] = useState('');
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'cardNumber') {
      const formattedValue = value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
      setFormData(prev => ({ ...prev, [name]: formattedValue }));
    }
    else if (name === 'expiryDate') {
      const formattedValue = value.replace(/\D/g, '').slice(0, 4);
      if (formattedValue.length >= 2) {
        const formatted = formattedValue.slice(0, 2) + '/' + formattedValue.slice(2, 4);
        setFormData(prev => ({ ...prev, [name]: formatted }));
      } else {
        setFormData(prev => ({ ...prev, [name]: formattedValue }));
      }
    }
    else if (name === 'cvv') {
      const numericValue = value.replace(/\D/g, '').slice(0, 4);
      setFormData(prev => ({ ...prev, [name]: numericValue }));
    }
    else if (name === 'amount') {
      const numericValue = value.replace(/[^\d.]/g, '');
      setFormData(prev => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitMessage('');
    setShowPaymentModal(true);
  };

  const handlePaymentSuccess = () => {
    setFormData({
      amount: '100.00',
      cardholderName: 'John Doe',
      cardNumber: '1234 5678 9012 3456',
      expiryDate: '12/30',
      cvv: '123',
      email: 'john@example.com'
    });
    setSubmitMessage('');
    onClose();
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        
        <button className="modal-close" onClick={onClose}>&times;</button>

        <div className="modal-sidebar">
          <div className="sidebar-content">
            <h3 className="sidebar-title">Payment Methods</h3>
            
            <div className="payment-logos-section">
              <div 
                className={`logo-item-selectable ${selectedCard === 'visa' ? 'selected' : ''}`}
                onClick={() => setSelectedCard('visa')}
              >
                <div className="card-logo visa-logo">
                  <svg viewBox="0 0 48 32" fill="none">
                    <rect width="48" height="32" rx="4" fill="#1434CB"/>
                    <text x="24" y="22" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold" fontFamily="Arial">VISA</text>
                  </svg>
                </div>
                <span className="logo-label">Visa</span>
                {selectedCard === 'visa' && <div className="selection-badge">✓</div>}
              </div>

              <div 
                className={`logo-item-selectable ${selectedCard === 'mastercard' ? 'selected' : ''}`}
                onClick={() => setSelectedCard('mastercard')}
              >
                <div className="card-logo mastercard-logo">
                  <svg viewBox="0 0 48 32" fill="none">
                    <rect width="48" height="32" rx="4" fill="#EB001B"/>
                    <circle cx="18" cy="16" r="8" fill="#FF5F00" opacity="0.8"/>
                    <circle cx="30" cy="16" r="8" fill="#FFB81C" opacity="0.8"/>
                  </svg>
                </div>
                <span className="logo-label">Mastercard</span>
                {selectedCard === 'mastercard' && <div className="selection-badge">✓</div>}
              </div>
            </div>

            {/* <div className="payment-features">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <p>Instant Processing</p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">🔒</div>
                <p>Secure Payment</p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">💰</div>
                <p>No Hidden Fees</p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <p>Verified Payment</p>
              </div>
            </div> */}
          </div>
        </div>

        <div className="modal-form-section">
          <div className="form-header">
            <h2>Add Funds to Your Account</h2>
          </div>

          <form className="deposit-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="amount">Deposit Amount (EUR)</label>
              <div className="amount-input-wrapper">
                <span className="currency-symbol">€</span>
                <input
                  type="text"
                  id="amount"
                  name="amount"
                  placeholder="100.00"
                  value={formData.amount}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="amount-suggestions">
                <button type="button" onClick={() => setFormData({...formData, amount: '50'})}>$50</button>
                <button type="button" onClick={() => setFormData({...formData, amount: '100'})}>$100</button>
                <button type="button" onClick={() => setFormData({...formData, amount: '500'})}>$500</button>
                <button type="button" onClick={() => setFormData({...formData, amount: '1000'})}>$1000</button>
              </div> */}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="cardholderName">Cardholder Name</label>
                <input
                  type="text"
                  id="cardholderName"
                  name="cardholderName"
                  placeholder="John Doe"
                  value={formData.cardholderName}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="cardNumber">Card Number</label>
              <input
                type="text"
                id="cardNumber"
                name="cardNumber"
                placeholder="1234 5678 9012 3456"
                maxLength="19"
                value={formData.cardNumber}
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="expiryDate">Expiry Date</label>
                <input
                  type="text"
                  id="expiryDate"
                  name="expiryDate"
                  placeholder="MM/YY"
                  maxLength="5"
                  value={formData.expiryDate}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="cvv">CVV</label>
                <input
                  type="text"
                  id="cvv"
                  name="cvv"
                  placeholder="123"
                  maxLength="4"
                  value={formData.cvv}
                  onChange={handleChange}
                />
              </div>
            </div>

            {submitMessage && (
              <div className={`submit-message ${submitMessage.includes('✓') ? 'success' : 'error'}`}>
                {submitMessage}
              </div>
            )}

            <button
              type="submit"
              className="deposit-button"
            >
              Deposit Now
            </button>

            <div className="security-note">
              🔒 Your payment information is encrypted and secure
            </div>
          </form>
        </div>

      </div>

      <PaymentSubModal
        isOpen={showPaymentModal}
        onClose={handleClosePaymentModal}
        onSuccess={handlePaymentSuccess}
        paymentData={formData}
      />
    </div>
  );
}

export default DepositModal;
